<template>
  <div class="inter-tool">
    <div class="card-group card">
      <div class="card-item" v-for="item in toolList" :key="item.key">
        <div class="card-item-top" @click="setOpenTool(item.key)" :class="{active:openTool===item.key}">
          <img class="icon" :src="require(`img/${item.key}.png`)" alt="">
          <div class="label">{{ isMobile ? '' : '选择' }}{{ item.label }}</div>
          <div class="btn">
            <div class="arrow" :class="{up:openTool===item.key}"></div>
          </div>
        </div>
        <div class="card-item-content" v-if="openTool===item.key&&openTool!=='car'">
          <template v-if="openTool!=='car'">
            <div class="card-content-item" v-for="cit in item.value" :key="cit.value"
                 @click="changeOuter(item.key,cit.value)"
                 :class="{active:cit.value===activeTool[item.key]}">
              <div class="cit-icon-box">
                <img class="cit-icon" :src="require(`img/${cit.value}.png`)"/>
              </div>
              <div class="cit-label">{{ cit.label }}</div>
              <div class="line"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {carConfig, interPositionTar} from "@/config";
import {isMobile} from "@/utils";

const toolKeys = ['car', 'pos']


export default {
  props: {
    activeInterColor: {
      type: String
    }
  },
  data() {
    const activeTool = {
      pos: 'main'
    }

    return {
      carConfig,
      openTool: '',
      openFunction: false,
      activeTool,
      isMobile,
    }
  },
  computed: {
    toolList: vm => [
      {
        key: 'car',
        label: '颜色',
      },
      {
        key: 'pos',
        label: '视角',
        value: carConfig.inter[vm.activeInterColor].map(pos => ({
          label: interPositionTar[pos],
          value: pos
        }))
      },
    ]
  },
  methods: {
    setOpenTool(key) {
      if(this.openTool === key){
        key=''
      }
      this.openTool = key
      this.$emit('setShowMobileColor', key === 'car')
    },
    changeOuter(accessory, styleName) {
      this.activeTool.pos = styleName
      this.$emit('selectInterPos', styleName)
    }
  }
}
</script>
